<!-- 显示二维码列表 -->
<template>
<div>
  <template v-for="item in qrs">
    <el-row :key="item.qrid">
      <el-col>
        <qrInfoPanel :qrinfo="item" :key="'info-' + item.qrid" :userLevel="userLevel"></qrInfoPanel>
      </el-col>
    </el-row>
  </template>
  <div v-if="qrs.length != 0" class="block" style="text-align: center;margin-bottom: 15px;">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="num"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElements">
    </el-pagination>
  </div>
</div>
</template>

<script type="text/javascript">
import qrInfoPanel from './qrInfoPanel.vue'
import $ from 'jquery'
export default {
  name: 'qrInfoList',
  data () {
    return {
      loading: false,
      error: null,
      qrs: [], // 页面中当前显示的二维码内容
      num: 10, // 页面中二维码显示时所用的查询条件（每页条数）
      page: 1, // 页面中二维码显示时所用的查询条件（页码)
      label: 'all',
      count: 0, // 该分类二维码总条数
      totalPages: 0,
      totalElements: 0,
      userLevel: 0 // 当前用户的等级
    }
  },
  components: {
    qrInfoPanel
  },
  mounted () {
    const vm = this
    $.ajax({
      type: 'GET',
      async: false,
      url: '/v1/userMessage',
      data: {},
      dataType: 'json',
      success: function (response) {
        vm.userLevel = response.data.level
      }
    })
    // 组件创建完后获取数据，
    // 此时 data 已经被 observed 了
    let label = this.$route.params.id
    let num = this.$route.params.num
    let page = this.$route.params.page
    if (isNaN(parseInt(label))) {
      this.label = 'all'
    } else {
      this.label = parseInt(label)
    }
    if (isNaN(parseInt(num))) {
      this.num = 10
    } else {
      this.num = parseInt(num)
    }
    if (isNaN(parseInt(page))) {
      this.page = 1
    } else {
      this.page = parseInt(page)
    }
    this.fetchData(this.label, this.num, this.page)
  },
  beforeRouteUpdate (to, from, next) {
    let label = to.params.id
    let num = to.params.num
    let page = to.params.page
    if (isNaN(parseInt(label))) {
      this.label = 'all'
    } else {
      this.label = parseInt(label)
    }
    if (isNaN(parseInt(num))) {
      this.num = 10
    } else {
      this.num = parseInt(num)
    }
    if (isNaN(parseInt(page))) {
      this.page = 1
    } else {
      this.page = parseInt(page)
    }
    this.fetchData(this.label, this.num, this.page)
    // 进行管道中的下一个钩子。如果全部钩子执行完了，则导航的状态就是 confirmed （确认的）。
    next()
  },
  methods: {
    handleSizeChange (val) {
      this.$router.push('/labelManage/labelid/' + this.label + '/n/' + val + '/p/' + this.page)
    },
    handleCurrentChange (val) {
      this.$router.push('/labelManage/labelid/' + this.label + '/n/' + this.num + '/p/' + val)
    },
    fetchData: function (label, num, page) {
      // 查询所有二维码
      const vm = this
      if (page < 1) {
        page = 1
      }
      if (num < 1) {
        num = 10
      }
      let paramData = {
        n: num,
        p: page
      }
      if (label !== 'all') {
        paramData.l = label
      }
      this.loading = true
      this.error = null
      $.ajax({
        url: '/v1/user/qrs',
        type: 'GET',
        dataType: 'json',
        data: paramData,
        success: function (data) {
          vm.loading = false
          if (data.code === 200) {
            // 获取数据成功，更新对应的查询条件，和相关的数据信息
            vm.qrs = data.data.content
            vm.page = data.data.number + 1
            vm.num = data.data.size
            vm.totalPages = data.data.totalPages
            vm.totalElements = data.data.totalElements
          } else {
            vm.$message.warning('获取列表失败，请稍后重试')
          }
        },
        error: function () {
          vm.$message.warning('异常，请稍后重试')
        }
      })
    }
  }
}
</script>

<style type="text/css" scoped>
/* Main */
.row{
  margin-left: 0px;
  margin-right: 0px;  
}
.panel-full{
  border: 0px;
  margin-left:15px;
  margin-right:15px;
  padding: 15px 0px;
}
.pagination>li.active>a {
  background-color: rgba(66,139,200,0.5);
}
</style>
